import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskAutomationEditRuleRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-automation-edit-rule',
	path: '/jira/servicedesk/projects/:projectKey/settings/automation/ruleset/:ruleId',
};
